import { render, staticRenderFns } from "./ExchangeRateCalculatorForm.vue?vue&type=template&id=b822ce64&"
import script from "./ExchangeRateCalculatorForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeRateCalculatorForm.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRateCalculatorForm.vue?vue&type=style&index=0&id=b822ce64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports